import { render, staticRenderFns } from "./FranchiseReportTable.vue?vue&type=template&id=68123d22&scoped=true&"
import script from "./FranchiseReportTable.vue?vue&type=script&lang=ts&"
export * from "./FranchiseReportTable.vue?vue&type=script&lang=ts&"
import style0 from "./FranchiseReportTable.vue?vue&type=style&index=0&id=68123d22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68123d22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VTextField})
